<template>
  <div id="filters">
    <slot name="button"  />

    <div :style="styles">
      <el-input
        v-model="search"
        :placeholder="placeholder"
        :size="size"
        clearable
      >
        <i slot="prefix" :class="iconClass" />
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    size: {
      type: String,
      default: 'medium'
    },
    icon: {
      type: String,
      default: 'search'
    },
    width: Number
  },
  data () {
    return {
      search: null
    }
  },
  computed: {
    iconClass () {
      return 'el-input__icon el-icon-' + this.icon
    },
    styles () {
      return {
        width: (this.width ? 'calc(100% - ' + (this.width + 10) + 'px)' : '100%')
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../theme";

  #filters {
    height: 36px;

    .el-button {
      float: left;
      height: 36px;
      border-color: transparent !important;
    }
    .el-button + div {
      float: left;
      margin-left: 10px;
    }
    .el-input__inner {
      background-color: transparent;
      border-color: transparent;

      &::placeholder {
        color: $--color-text-gray;
        opacity: 1; /* Firefox */
      }
      & + .el-input__prefix .el-icon-search:before {
        color: $--color-text-gray;
      }
    }
    .el-input__inner:focus, .el-input__inner:hover {
      background-color: #fff;
      border-color: $--color-primary;

      & + .el-input__prefix .el-icon-search:before {
        color: $--color-primary;
      }
    }

  }
</style>
